import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "pass",
  computed: {
    ...userVuex.mapState(["isLogin", "balanceInfo", "userInfo", "didInfo"])
  },
  data() {
    const wayList = [{
      name: "Level Up",
      path: "/upgrade"
    }, {
      name: "Complete Tasks",
      path: "/rewards"
    }, {
      name: "Spin & Win",
      path: "/turn"
    }];
    return {
      wayList
    };
  }
};